import { Component } from '@angular/core';

import { FacilityPage } from "../facility/facility";
import { UnitPage } from "../unit/unit";
import { ArticlePage } from "../article/article";

import { SettingPage } from '../setting/setting';

import { Tabs } from 'ionic-angular/components/tabs/tabs';
import { ViewChild } from '@angular/core';

import { NavParams, NavController, App } from 'ionic-angular';

@Component({
  templateUrl: 'home.html'
})
export class HomePage {
  @ViewChild("tabs") tabRef: Tabs;

  tab1Root = FacilityPage;
  tab2Root = UnitPage;
  tab3Root = ArticlePage;
  tab4Root = SettingPage;

  private params: any;

  constructor(public navParams: NavParams, public navCtrl: NavController, public app: App) {
    //    console.log("0");
  }

  ionViewWillEnter() {
    //  TODO: Determine the condition that will set this attribute.
    let isAdmin: boolean = true;
    this.conditionallyInjectAdminMenu(isAdmin);
  }

  ionViewDidLoad() {
//    console.log("1");
  }

  ionViewDidEnter() {
//    console.log("3");
  }

  ionViewWillLeave() {
//    console.log("4");
  }

  ionViewDidLeave() {
//    console.log("5");
  }

  ionViewWillUnload() {
//    console.log("6");
  }

  ionViewCanEnter() {
//    console.log("7");
  }

  ionViewCanLeave() {
//    console.log("8");
  }

  private conditionallyInjectAdminMenu(isAdmin) {
    for (let tab of this.tabRef._tabs) {
      if (tab.tabTitle == "Home") {
        tab.rootParams = this.params;
        break;
      }

      if (tab.tabTitle == "Admin") {
        tab.show = isAdmin;
        tab.rootParams = this.params;
        break;
      }
    }
  };

  public logOut() {
    const root = this.app.getRootNav();
    root.popToRoot();
  };

  public doSettings() {
    this.navCtrl.push(SettingPage);
  };
}


// WEBPACK FOOTER //
// ./src/pages/home/home.ts